import axios from "../../axiosDod.js";

const addMessage = async (_, data) => {
  const {
    text,
    admin,
    type,
    employeeId,
    customerId,
    taskId,
    isAction,
    filesIds,
  } = data;
  try {
    const response = await axios.post(`messages`, {
      text,
      admin,
      type,
      employeeId,
      customerId,
      taskId,
      isAction,
      filesIds: filesIds ? filesIds : [],
    });
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

const deleteMessage = async (_, messageId) => {
  try {
    const response = await axios.delete(`messages/${messageId}`);
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

const editMessage = async (_, data) => {
  try {
    const { messageId, text } = data;
    const response = await axios.put(`messages/${messageId}`, {
      text,
    });
    return response.data;
  } catch (error) {
    throw error.response;
  }
};

export default {
  addMessage,
  deleteMessage,
  editMessage,
};
